import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-line-separator',
  templateUrl: './line-separator.component.html',
  styleUrls: ['./line-separator.component.scss']
})
export class LineSeparatorComponent extends FieldType<FieldTypeConfig> {

}
